import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {SchemeDto} from './scheme.dto';
import {map, Observable} from 'rxjs';
import {mapScheme} from './scheme.mapper';
import {Scheme} from '../domain/scheme.model';

@Injectable({ providedIn: 'root' })
export class SchemeService {
  private readonly http = inject(HttpClient);

  private getSchemeDtoResult(schematicId: string): Observable<SchemeDto> {
    return this.http.get<SchemeDto>(`/api/schematics/by-schematic-id/${schematicId}`);
  }

  public getScheme(schematicId: string): Observable<Scheme> {
    return this.getSchemeDtoResult(schematicId).pipe(
      map(mapScheme)
    )
  }
}
